<div class="receive-code">
  <div class="receive-code__title">
    <h3>{{ 'forgotPassword.title' | translate }}</h3>
    <p>{{ 'forgotPassword.receiveCode.message' | translate }}</p>
  </div>

  <form 
    autocomplete="off"
    [formGroup]="form"
    (submit)="submit()"
  >
    <cx-input-field
      [label]="'forgotPassword.user' | translate"
      formControlName="username"
      [control]="form.get('username')"
      [invalid]="!!(error$ | async)"
      [hintText]="(error$ | async) ?? ''"
    />

    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="form.invalid || (isLoading$ | async)"
    >
      @if (isLoading$ | async) {
        <local-loader />
      }
      @else {
        {{ 'forgotPassword.receiveCode.submit' | translate }}
      }
    </button>
  </form>
</div>
